import React from 'react';
import Highlighter from 'react-highlight-words';
import GlobalSearchCard from '../GlobalSearchCard';

interface IcServiceRequest {
  title: string;
  url: string;
  key: string;
  description: string;
  catalog: any;
  category: any;
  created: any;
  created_by: any;
  id: string;
  image: string;
  name: string;
  presentation: string;
  short_description: string;
  type: string;
  updated: any;
  updated_by: string;
}

export interface IcServiceRequestProps {
  item: IcServiceRequest;
  pathArray: [string, string];
  keywords?: string[];
  onClickViewDetail?: () => void;
  standalone?: boolean;
  locale?: Record<string, any>;
}

const IcServiceRequestCard = (props: IcServiceRequestProps) => {
  const { item, keywords = [], onClickViewDetail, locale, pathArray, standalone} = props;
  const mapBreadcrumb = () => {
    return pathArray.map((path) => locale?.breadcrumb?.[path] || path).join(' / ');
  };

  return (
    <GlobalSearchCard
      title={
        <Highlighter
          highlightClassName="activeHighlight"
          searchWords={keywords}
          textToHighlight={item?.title || item?.name}
          autoEscape
        />
      }
      standalone={standalone}
      description={item?.description ?? ''}
      breadcrumbs={mapBreadcrumb()}
      onClickViewDetail={onClickViewDetail}
      locale={locale}
      paperProps={{ 'data-catalog_id': item?.id }}
    >
    </GlobalSearchCard>
  );
};

export default IcServiceRequestCard;
